export const calculateDrivingScore = ({ speed, rpm, throttle, engine_load }) => {
    let score = 100;
    if (speed > 100) score -= 10;
    if (speed > 130) score -= 20;
    if (rpm > 4000) score -= 15;
    if (throttle > 80) score -= 10;
    if (engine_load > 90) score -= 5;
    return Math.max(0, Math.min(100, score));
};

export const calculateHealthScore = ({ coolant, voltage, catalyst, stft, ltft }) => {
    let score = 100;
    if (coolant > 105) score -= 30;
    if (coolant > 115) score -= 50;
    if (voltage < 12.0 || voltage > 15.0) score -= 20;
    if (catalyst > 900) score -= 15;
    if (Math.abs(stft) > 20) score -= 10;
    if (Math.abs(ltft) > 20) score -= 10;
    return Math.max(0, Math.min(100, score));
};

export const analyzeCoolant = (temp) => {
    if (temp < 60) return { text: "Warming Up", color: "text-blue-500", status: "blue" };
    if (temp <= 105) return { text: "Optimal", color: "text-emerald-600", status: "green" };
    return { text: "Overheating", color: "text-red-600 animate-pulse", status: "red" };
};

export const analyzeCatalyst = (temp) => {
    if (temp < 300) return { text: "Cold", color: "text-blue-500", status: "blue" };
    if (temp <= 800) return { text: "Efficient", color: "text-emerald-600", status: "green" };
    return { text: "High Temp", color: "text-red-600", status: "red" };
};

export const analyzeFuelTrim = (val) => {
    if (Math.abs(val) < 10) return { text: "Balanced", color: "text-emerald-600", status: "green" };
    const condition = val > 0 ? "Lean (+)" : "Rich (-)";
    return { text: condition, color: "text-amber-500", status: "yellow" };
};

export const analyzeVoltage = (v) => {
    if (v < 12) return { text: "Weak Battery", color: "text-red-600", status: "red" };
    if (v <= 14.8) return { text: "Charging", color: "text-emerald-600", status: "green" };
    return { text: "Surge Detected", color: "text-red-600", status: "red" };
};

export const analyzeEngineLoad = (load) => {
    if (load < 20) return { text: "Idle/Coast", color: "text-blue-500", status: "blue" };
    if (load < 80) return { text: "Normal", color: "text-emerald-600", status: "green" };
    return { text: "High Load", color: "text-red-600", status: "red" };
};

export const formatRuntime = (sec = 0) => {
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    return `${h}h ${m}m`;
};
